import { viewStorage } from '../_globals'

/**
 * EcosystemList Module
 * Gère l'affichage et la navigation des listes d'écosystème (members, partners, framework-organisations)
 */
export default class EcosystemList {
  
  constructor(container, urlajax) {
    if (!container || !urlajax) {
      console.warn('EcosystemList: container or urlajax missing')
      return
    }

    this.container = container
    this.urlajax = urlajax
    this.page = 1
    this.term_slug = 'members'
    
    this.init()
  }

  init() {
    this.menuNavResults = viewStorage.current.querySelectorAll('.results-list--menu-item')
    this.resultsLists = viewStorage.current.querySelectorAll('.results-list--items-wrapper')
    this.resultsIntros = viewStorage.current.querySelectorAll('.results-intro')

    if (!this.menuNavResults.length) {
      console.warn('EcosystemList: No menu items found')
      return
    }

    this.bindEvents()
    this.handleAnchor()
    this.runSearch()
  }

  bindEvents() {
    // Ecosystem toggle results list
    this.menuNavResults.forEach(tab => {
      tab.addEventListener('click', (e) => {
        this.menuNavResults.forEach(t => t.classList.remove('--active'))
        this.resultsLists.forEach(t => t.classList.remove('--active'))
        this.resultsIntros.forEach(item => item.classList.remove('--active'))
        
        e.currentTarget.classList.add('--active')
        const currentType = e.currentTarget.getAttribute('data-slug')
        const currentListResults = document.getElementById('results--' + currentType)
        const currentIntroResults = document.getElementById('results-intro--' + currentType)
        
        currentListResults.classList.add('--active')
        currentIntroResults.classList.add('--active')
        
        this.term_slug = currentType
        this.page = 1
        this.runSearch()
      })
    })
  }

  handleAnchor() {
    // Opening menu depending on anchor
    const url = window.location.href
    const anchor = url.substr(url.indexOf("#"))
    const anchor2 = anchor.replace("#", "")
    
    if ((anchor2 != '/') && (anchor2 != '') && anchor2 != undefined) {
      this.menuNavResults.forEach(tab => tab.classList.remove('--active'))
      this.resultsLists.forEach(tab => tab.classList.remove('--active'))
      this.resultsIntros.forEach(item => item.classList.remove('--active'))
      
      const currentListResults2 = viewStorage.current.querySelector('#results--' + anchor2)
      const currentIntroResults2 = document.getElementById('results-intro--' + anchor2)
      const currentMenuResults = viewStorage.current.querySelector('.results-list--menu-item[data-slug="' + anchor2 + '"]')
      
      if (currentListResults2) currentListResults2.classList.add('--active')
      if (currentIntroResults2) currentIntroResults2.classList.add('--active')
      if (currentMenuResults) currentMenuResults.classList.add('--active')
    }
  }

  runSearch() {
    const formData = new FormData()
    formData.append('page', this.page)
    formData.append('term_slug', this.term_slug)
    
    const xhr = new XMLHttpRequest()
    xhr.open('POST', this.urlajax, true)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        switch (xhr.status) {
          case 200:
            this.onSuccess(xhr.responseText)
            break
          case 422:
            break
          default:
            break
        }
      }
    }
    xhr.send(formData)
  }

  onSuccess(responseText) {
    const json = JSON.parse(responseText)
    const currentListResults = document.getElementById('results--' + this.term_slug)
    
    if (currentListResults) {
      currentListResults.innerHTML = json.listPosts_html
      this.initPaginationListeners()
    }
  }

  initPaginationListeners() {
    const buttons = document.querySelectorAll('.more-post')
    buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.page = this.page + 1
        this.runSearch()
      })
    })
  }

  destroy() {
    // Cleanup if needed
  }
}

